import React from 'react';
import AppointmentRegistration from './AppointmentRegistration';
export default function RsvRegistration() {return <AppointmentRegistration project="RSV"/>;}
